<template>
	<section class="view-venue-nearby places-nearby default-panel">
		<ViewLayoutModuleHeader class="padded" title="Places nearby">
			<RouterLink
				v-bind:to="{
					hash: `#latitude=${venueModel.getLatitude()}&longitude=${venueModel.getLongitude()}`,
					name: 'PageMap',
				}"
			>
				View Map
			</RouterLink>
		</ViewLayoutModuleHeader>

		<ChalkyVenueList
			v-bind:venueCollection="venueCollection"
			v-bind:view="grid ? 'grid' : 'horizontal'"
			v-on:venue:select="Handle_OnSelectVenue"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays a horizontal list of nearby venues with a link to view on map.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueNearby extends ViewBase {
		/**
		 * If we want to display as grid
		 * @type boolean
		 */
		@Prop({ default: false })
		public grid!: boolean;

		/**
		 * The venue model used to get lat/long for the map link
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;

		/**
		 * Collection of nearby venues to display
		 *
		 * @type ChalkySticks.Collection.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.collection(),
		})
		public venueCollection!: ChalkySticks.Collection.Venue;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Emits the selected venue to the parent component
		 *
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return void
		 */
		protected Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): void {
			this.$emit('venue:select', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-venue-nearby {
		.view-layout-moduleheader {
			margin-bottom: 0;
		}

		.list .venue-card:first-child {
			display: none;
		}

		.chalky.venue-list.view-horizontal .list {
			padding-bottom: 1rem;
		}
	}
</style>
